import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import TableComponent from '../../common/table/Table';
import ApproveBotton from '../../common/approveBotton/ApproveBotton';

const columns = [
  { id: 'user_name', label: 'Funcionario', align: 'left' },
  { id: 'registration_date', label: 'Data', align: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const CoachConsult = ({ handleChangeComponent }) => {
  const [rows, setRows] = useState([]);

  const handleConsultLinkSectorUser = useCallback(async () => {
    const result = await AxiosInstance.get('/training/get-coach');
    const temp = result?.data?.rows?.map((item) => ({
      ...item,
      ativo: item.active ? 'ATIVADO' : 'DESATIVADO',
      acao: (
        <ApproveBotton
          title="Editar Sub-Setor"
          url="/training/active-coach"
          item={item}
          handleChangeComponent={handleChangeComponent}
          handleCosnult={handleConsultLinkSectorUser}
          edit={false}
        />
      ),
    }));
    setRows(temp);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleConsultLinkSectorUser();
  }, [handleConsultLinkSectorUser]);

  return (
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          <Button
            variant="contained"
            fullWidth
            onClick={() =>
              handleChangeComponent('Liberar acesso a criação de treinamentos', 'create')
            }
          >
            cadastrar
          </Button>
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableComponent columns={columns} rows={rows} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CoachConsult;
